export const ORDER_TYPE_AUTOSHIP = 'autoship';
export const ORDER_TYPE_CSR = 'csr';
export const ORDER_TYPE_FIRST_AUTOSHIP = 'first_autoship';
export const ORDER_TYPE_IMMEDIATE_AUTOSHIP = 'immediate_autoship';
export const ORDER_TYPE_REGULAR = 'regular';
export const ORDER_TYPE_REGULAR_AUTOSHIP = 'regular_autoship';

export const PREMIER_VALUE = 1;
export const ON_DEMAND_VALUE = 2;
export const RETURN_VALUE = 3;

export const ORDER_TYPE = {
  [ORDER_TYPE_AUTOSHIP]: PREMIER_VALUE,
  [ORDER_TYPE_CSR]: ON_DEMAND_VALUE,
  [ORDER_TYPE_FIRST_AUTOSHIP]: PREMIER_VALUE,
  [ORDER_TYPE_IMMEDIATE_AUTOSHIP]: PREMIER_VALUE,
  [ORDER_TYPE_REGULAR]: ON_DEMAND_VALUE,
  [ORDER_TYPE_REGULAR_AUTOSHIP]: PREMIER_VALUE,
};
